import { MealPlanPreference } from "../../models";

interface Option {
	key: number;
	text: string;
	description?: string;
}

export enum MealPlanPreferenceName {
	people = 'people',
	dietaryNeeds = 'dietaryNeeds',
}

export enum MealPlanNonPreferenceStepName {
	splash = 'splash',
	finalising = 'finalising',
}

export type MealPlanStepName = MealPlanPreferenceName | MealPlanNonPreferenceStepName;

export type PreferenceValue = string[] | { [key: string]: number };



export interface MealPlanStep extends Omit<MealPlanPreference, 'value'> {
	options?: Option[];
	value?: PreferenceValue;
	default?: PreferenceValue;
	active: boolean;
}

export interface ChooseMealPlanState {
	completed: boolean;
	steps: MealPlanStep[];
}

export interface ActiveMealPlanStep extends MealPlanStep {
	currentStep: number;
	totalSteps: number;
}
